import { Typography } from '@mui/material';
import React from 'react';
import { DropdownV2 } from '@warehouse/shared/ui';
import { FieldWrapper } from '../../ui/FieldWrapper';

export function CompObjPrimaryField({ primary, onPrimaryChange, onBlur }: CompObjPrimaryFieldProps) {
    const label = 'Primary';

    return (
        <FieldWrapper className="field-wrapper">
            <Typography variant="buttonMediumMedium" color="text.primary">
                {label}
            </Typography>
            <DropdownV2
                ariaLabel={label}
                value={primary}
                onBlur={onBlur}
                options={options}
                onChange={onPrimaryChange}
                disabledMargin
            />
        </FieldWrapper>
    );
}

const options = [
    {
        value: true,
        label: 'True',
    },
    {
        value: false,
        label: 'False',
    },
];

export type CompObjPrimaryFieldProps = {
    primary: boolean;
    onPrimaryChange: (primary: boolean) => void;
    onBlur: () => void;
};
